




























import { Vue, Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
// @ts-ignore
import localeDatePicker from 'ant-design-vue/lib/date-picker/locale/fr_FR';

@Component({})
export default class BookingAskSignature extends Vue {
    @Prop({ type: Boolean, default: false }) disabled!: boolean;
    @Prop({ type: Boolean, default: false }) firewallDisabled!: boolean;
    @Prop({ default: 'Valider' }) label!: string;
    @Prop({ default: () => () => true }) onDate!: (
        date: moment.Moment
    ) => Promise<boolean>;

    localeDatePicker = localeDatePicker;
    showDateSelection: boolean = false;
    date: moment.Moment | null = null;
    loading: boolean = false;

    click() {
        if (this.disabled) {
            return;
        }

        if (this.firewallDisabled) {
            this.$emit('action');
            return;
        }

        this.showDateSelection = true;
    }

    async valid() {
        if (!this.date) {
            return;
        }

        this.loading = true;
        if (await this.onDate(this.date)) {
            this.showDateSelection = false;
            this.$emit('action');
        }
        this.loading = false;
    }

    disabledDate(current: moment.Moment) {
        return current && current < moment().startOf('day');
    }
}
